import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

// Some design-system SVG icons are exported from Figma wrapped in a bounding-box
// `clip-path` (`<g clip-path="url(#id)">` + a `<clipPath>` with a full-size rect).
// Because the apps declare a `<base href>`, the browser resolves that `url(#id)`
// against the current route (e.g. `url(/clients/123?...#id)`), which breaks the
// reference and clips the whole icon out, so it renders blank.
//
// The clip is a no-op (it matches the full 24x24 viewBox), so we strip the
// `clip-path` attribute from the fetched SVG. This makes those icons render
// reliably regardless of the current route or of other icon instances mounted.
@Injectable()
export class SvgIconClipPathInterceptor implements HttpInterceptor {
  private static readonly ICONS_PATH = "/icons/figma/";
  private static readonly CLIP_PATH_ATTR = /\s*clip-path="[^"]*"/g;

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const is_ds_icon = request.url.includes(SvgIconClipPathInterceptor.ICONS_PATH) && request.url.endsWith(".svg");
    if (!is_ds_icon) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      map((event) => {
        const has_clip_path =
          event instanceof HttpResponse && typeof event.body === "string" && event.body.includes("clip-path");
        if (!has_clip_path) {
          return event;
        }
        return (event as HttpResponse<string>).clone({
          body: (event as HttpResponse<string>).body.replace(SvgIconClipPathInterceptor.CLIP_PATH_ATTR, ""),
        });
      })
    );
  }
}
